import { render, staticRenderFns } from "./TitleSetting.vue?vue&type=template&id=6013f06b&"
import script from "./TitleSetting.vue?vue&type=script&lang=js&"
export * from "./TitleSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports